import React from 'react'
import MediaQuery, { useMediaQuery } from 'react-responsive'
import { useHistory } from 'react-router-dom'

import { AcornsIcon, Icon } from '@acorns/icons'
import { Spinner } from '@acorns/web-components'
import { useAnalyticsClient } from '@acorns/web-utils'

import {
  SplitDepositSettingType,
  useCombinedPerformanceQuery,
  usePresentInvestmentsTotalsQueryQuery,
} from 'generated/types'
import { routes } from 'router/routes'
import themeValues from 'theme'
import theme from 'theme'

import { onTabButtonSettingsTapped, onTabButtonTapped } from './events'
import { BaseRoutes } from './SideBar'
import { Balance, ProductLink, ProductTitle } from './styled-components'
import { isActivePath } from './utils'

// CUSTOM_SMALL_DESKTOP only use for ActionStrip, therefore defining here in web-app (not web-core)
// Summarize from previous command, check git blame for original
const CUSTOM_SMALL_DESKTOP = 1050

export enum WebPlatformType {
  TABLET = 'web tablet',
  DESKTOP = 'web desktop',
}

type Props = {
  balance?: string
  baseRoutes: BaseRoutes[]
  icon: Icon
  index: number
  isBottomElement?: boolean
  link: string
  testId?: string
  title: string
}

const SideBarLink = ({
  balance,
  baseRoutes,
  icon,
  index,
  isBottomElement = false,
  link,
  title,
}: Props) => {
  const history = useHistory()
  const analytics = useAnalyticsClient()

  const {
    loading: combinedPerformanceDataLoading,
    refetch: combinedPerformanceDataRefetch,
  } = useCombinedPerformanceQuery({
    variables: { days: -1 },
  })

  const { loading: investmentsTotalLoading, refetch: investmentsTotalRefetch } =
    usePresentInvestmentsTotalsQueryQuery({
      variables: {
        settingTypes: [
          SplitDepositSettingType.DirectDeposit,
          SplitDepositSettingType.DirectDepositIntent,
        ],
      },
    })

  const loading = investmentsTotalLoading || combinedPerformanceDataLoading

  const platform = useMediaQuery({
    query: `(max-width: ${CUSTOM_SMALL_DESKTOP}px) and (min-width: ${theme.breakpoints.sm}px)`,
  })
    ? WebPlatformType.TABLET
    : WebPlatformType.DESKTOP

  const handleClick = () => {
    if (link !== routes.settings.index) {
      analytics.track(
        'Button Tapped',
        onTabButtonTapped(title, platform, index),
      )
    } else {
      analytics.track(
        'Button Tapped',
        onTabButtonSettingsTapped(title, platform),
      )
    }
    combinedPerformanceDataRefetch()
    investmentsTotalRefetch()
  }

  const activePathPrefix = history.location.pathname.split('/')[1]

  return (
    <ProductLink
      key={title}
      activeProduct={isActivePath(baseRoutes, activePathPrefix)}
      onClick={handleClick}
      className={title}
      to={link}
    >
      <AcornsIcon icon={icon} height={24} width={24} />
      <MediaQuery minWidth={themeValues.breakpoints.sm + 1}>
        <ProductTitle data-testid={title} isBottomElement={isBottomElement}>
          {title}
        </ProductTitle>
        <MediaQuery minWidth={CUSTOM_SMALL_DESKTOP + 1}>
          {balance && loading ? (
            <Balance>
              <Spinner color="grey" width={24} height={24} />
            </Balance>
          ) : (
            <Balance>{balance}</Balance>
          )}
        </MediaQuery>
      </MediaQuery>
    </ProductLink>
  )
}
export { SideBarLink }
